"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGyroConfig = exports.getAccelConfig = exports.getPPGConfig = exports.getEEGConfig = void 0;
const c = __importStar(require("./constants"));
function getEEGConfig(type) {
    switch (type) {
        case 'Muse':
            return { yDomain: [-500, 500], channelNames: c.MUSE_EEG_CHANNELS };
        case 'Insai_TMS':
            return { yDomain: [-1000, 1000], channelNames: c.INSAI_EEG_CHANNELS };
        default:
            return { yDomain: [] };
    }
}
exports.getEEGConfig = getEEGConfig;
function getPPGConfig(type) {
    switch (type) {
        case 'Muse':
            return { yDomain: [-100, 100], channelNames: c.MUSE_PPG_CHANNELS };
        case 'Insai_TMS':
            return { yDomain: [-100, 100], channelNames: c.INSAI_PPG_CHANNELS };
        default:
            return { yDomain: [] };
    }
}
exports.getPPGConfig = getPPGConfig;
function getAccelConfig(type) {
    switch (type) {
        case 'Muse':
            return { yDomain: [-1, 1], channelNames: c.MUSE_ACCELEROMETER_CHANNELS };
        case 'Insai_TMS':
            return { yDomain: [-1, 1], channelNames: c.INSAI_MOTION_CHANNELS };
        default:
            return { yDomain: [] };
    }
}
exports.getAccelConfig = getAccelConfig;
function getGyroConfig(type) {
    switch (type) {
        case 'Muse':
            return { yDomain: [-100, 100], channelNames: c.MUSE_GYRO_CHANNELS };
        case 'Insai_TMS':
            return { yDomain: [-100], channelNames: c.INSAI_MOTION_CHANNELS };
        default:
            return { yDomain: [] };
    }
}
exports.getGyroConfig = getGyroConfig;
//# sourceMappingURL=plot-utils.js.map